import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ChangePasswordComponent } from './change-password/change-password.component';
//import { MessagingComponent } from './messaging/messaging/messaging.component';
import { ProfileComponent } from './profile/profile.component';
import { CookieService } from 'ngx-cookie-service';
import { UserInfosComponent } from './user-infos/user-infos.component';

@NgModule({
	declarations: [
		ProfileComponent,
		ChangePasswordComponent,
		UserInfosComponent,
	],
	imports: [SharedModule],
	providers: [CookieService]
})
export class ProfileModule {}
